import Vue from 'vue'
import App from '@/App.vue'
import store from '@/store'
import Lottie from 'vue-lottie'
// import './registerServiceWorker'
import Package from '../package'
// i18n Always before router
import i18n from './initI18n'
import router from './router'

import Conf from '../configuration'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMq from 'vue-mq'
import VueLazyload from 'vue-lazyload'
import * as Sentry from '@sentry/browser'
import VueOffline from 'vue-offline'

import Env from '@/modules/env'
import Firebase from './modules/firebase'
import IndexedDb from './modules/indexedDb'


Vue.config.productionTip = false

// Remove img drag on firefox for cards system on desktop
document.addEventListener('dragstart', function (e) {
    e.preventDefault()
})

// filters
Vue.filter('capitalizeFirstLetter', function (string) {
    if (string) {
        string = string.toString()
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
    return ''
})
Vue.filter('toUpperCase', function (string) {
    if (string) {
        string = string.toString()
        return string.toUpperCase()
    }
    return ''
})


if(!Env.isLocal()) {

    Sentry.init({
        dsn: Conf.sentry.sentryUrl,
        integrations: [new Sentry.Integrations.Vue({ Vue })],
        environment: Conf.environment,
        release: `app-cleanfox-v3-web@${ Package.version }`
    })
}

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: Conf.size.tablet,
        md: Conf.size.desktop,
        lg: Infinity
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.use(Lottie)
Vue.use(VueResource)
Vue.use(Vue2TouchEvents)
Vue.use(VueOffline)


Vue.use(VueLazyload, {
    preLoad: 1
})

Firebase.init()
IndexedDb.init()

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
